/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_TranscriptsInputs */

const en_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripts`)
};

const fr_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcriptions`)
};

const de_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkripte`)
};

const it_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizioni`)
};

const ru_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стенограммы`)
};

const es_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripciones`)
};

const zh_cn2_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成绩单`)
};

const ja_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプト`)
};

const hi_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेप`)
};

const pt_pt2_preset_manager_tab_transcripts = /** @type {(inputs: Preset_Manager_Tab_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrições`)
};

/**
* | output |
* | --- |
* | "Transcripts" |
*
* @param {Preset_Manager_Tab_TranscriptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_transcripts = /** @type {((inputs?: Preset_Manager_Tab_TranscriptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_TranscriptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_tab_transcripts(inputs)
	if (locale === "de") return de_preset_manager_tab_transcripts(inputs)
	if (locale === "it") return it_preset_manager_tab_transcripts(inputs)
	if (locale === "ru") return ru_preset_manager_tab_transcripts(inputs)
	if (locale === "es") return es_preset_manager_tab_transcripts(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_tab_transcripts(inputs)
	if (locale === "ja") return ja_preset_manager_tab_transcripts(inputs)
	if (locale === "hi") return hi_preset_manager_tab_transcripts(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_tab_transcripts(inputs)
	return en_preset_manager_tab_transcripts(inputs)
});